module.exports = __webpack_public_path__ + "img/player-en.c0ba7554.webp";